import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { Checkbox } from '@/components/ui/Form/Checkbox';
import { SelectableListItem } from '@/components/ui/List/SelectableList';
import { PinOffIcon, PinOnIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { SmallTag } from '@/components/ui/Tag/SmallTag';
import { Text } from '@/components/ui/Typography/Body/Text';
import Tooltip from '@/container/Ui/Tooltip/Tooltip';
import { hotlineClientNegotiateListItemStyle } from '@/feature/hotline/client/detail/negotiate/component/HotlineClientNegotiateListItem/style';
/**
 * 匿名コンサルホットライン クライアント チャット一覧 項目
 */
export const HotlineClientNegotiateListItem = (props) => {
    const { checked, className = '', companyName, disabledCheck, hasFirstAndLastBorder, hasUnAnswer, id, isClipped = false, isSelected, onChangeCheckbox: propOnChangeCheckbox, onClickClip: propOnClickClip, onClickItem: propOnClickItem, unReadCount, } = props;
    /**
     * 項目をクリックした際の処理
     */
    const onClickItem = useCallback(() => {
        propOnClickItem(id);
    }, [id, propOnClickItem]);
    /**
     * クリップボタンをクリックした際の処理
     */
    const onClickClip = useCallback(() => {
        propOnClickClip(id);
    }, [id, propOnClickClip]);
    /**
     * チェックボックスを変更した際の処理
     */
    const onChangeCheckbox = useCallback(() => {
        propOnChangeCheckbox(id);
    }, [id, propOnChangeCheckbox]);
    const style = hotlineClientNegotiateListItemStyle();
    return (_jsxs(SelectableListItem, Object.assign({ className: style.base({ class: className }), classNameChildrenWrap: style.item(), hasFirstAndLastBorder: hasFirstAndLastBorder, isSelected: isSelected, onClick: onClickItem, withoutButtonContent: _jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: style.buttonWrap() }, { children: _jsx(Tooltip, Object.assign({ arrow: true, distance: 16, html: isClipped ? 'ピンを外す' : 'ピン留めする', position: 'top' }, { children: _jsx("button", Object.assign({ className: style.button(), onClick: onClickClip, type: 'button' }, { children: isClipped ? (_jsx(PinOnIcon, { color: 'secondary', size: 'sm' })) : (_jsx(PinOffIcon, { className: style.pinOffIcon(), color: 'base', size: 'sm' })) })) })) })), _jsx(Checkbox, { checked: checked, className: style.checkbox(), disabled: disabledCheck, onChange: onChangeCheckbox })] }) }, { children: [_jsxs("div", { children: [_jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: companyName })), hasUnAnswer && (_jsx(SmallTag, Object.assign({ className: style.tag(), color: 'info', isKanjiTopFixed: true }, { children: "\u672A\u8FD4\u4FE1\u3042\u308A" })))] }), unReadCount > 0 && (_jsx(NumberBadge, { className: style.numberBadge(), number: unReadCount }))] })));
};
